import React from 'react'
import { HomeownerDashboard } from 'src/Components/homeowners/Breakpoint'
import MortgagesPanel from './MortgagesPanel'
import MortgagesModal from './MortgagesModal'

const Mortgages = () => (
  <>
    <HomeownerDashboard.Small>
      <span styles='margin-bottom:0'>
        <MortgagesModal>
          <MortgagesPanel />
        </MortgagesModal>
      </span>
    </HomeownerDashboard.Small>
    <HomeownerDashboard.Large>
      <MortgagesPanel />
    </HomeownerDashboard.Large>
  </>
)

export default Mortgages
